import { createSelector } from 'reselect';
import { RootState } from '../root.reducer';
import { LodgeEnquiryState } from 'types';

const selectCache = (state: RootState) => state.lodgeEnquiryCache;

export const selectIsSubmitting = createSelector(
  selectCache,
  (cache: any) => cache.submitting
);

export const selectEnquiryJobDetails = createSelector(
  selectCache,
  (cache: any) => cache.job
);

export const selectNewEnquiryDetails = createSelector(
  selectCache,
  (cache: any) => cache.enquiry
);

export const selectErrorMessage = createSelector(
  selectCache,
  (cache: any) => cache.errors
);

export const selectShape = createSelector(
  selectCache,
  (cache: any) => cache.shape
);

export const selectAddress = createSelector(
  selectCache,
  (cache: any) => cache.address
);

export const selectLastEnquiry = createSelector(
  selectCache,
  (cache: any) => cache.lastEnquiry
);

export const selectChannelTestMode = createSelector(
  selectCache,
  (cache: any) => cache.channelTestMode
);

export const selectEnquiryPresets = createSelector(
  selectCache,
  (cache: any) => cache.presets
);

export const selectLiveArea = createSelector(
  selectCache,
  (cache: any) => cache.liveArea
);

export const selectPrePopulatedData = createSelector(
  selectCache,
  (cache: LodgeEnquiryState) => cache.prePopulatedData
);
